import React, {useState} from 'react';
import {Col, Row, Spinner, Table} from "react-bootstrap";
import styles from "./participant-details-modal-content.module.scss";
import {dateBetween, formatDate, strToDate, toCurrency} from "../../../../../../helpr/helper";
import {required} from "../../../../../../helpr/generic-validation-rules";
import {useValidation} from "../../../../../../hooks/use-validation";
import checkIcon from "../../../../../../assets/orders-table-accept.svg";
import rejectIcon from "../../../../../../assets/orders-table-reject.svg";
import editIcon from "../../../../../../assets/edit.svg";
import {CurrencyInput, TextInput} from "../../../../../../components/form/form";
import ListingService from "../../../../../../services/listing-service";
import {LISTING_REVISE_ALLOCATION_ERROR, LISTING_REVISE_ALLOCATION_SUCCESS} from "../../../../../../helpr/constants";

const ParticipantDetailsModalContent = ({termSheet, participant, setParticipantList, onClose, admin, editAllowed}) => {
  return (
    <div className={styles['participant-details-modal-content']}>
      {
        participant.current.role === 'SellingAgent' ? (
          <>
            <ParticipantBasicDetails participant={participant} securityList={termSheet.securityList} />
            <ParticipantAllocationDetails termSheet={termSheet} participant={participant} setParticipantList={setParticipantList} admin={admin} editAllowed={editAllowed}/>
          </>
        ) : (
          <ParticipantBasicDetails participant={participant} securityList={termSheet.securityList}/>
        )
      }
    </div>
  )
}

const ParticipantBasicDetails = ({participant, securityList}) => {
  console.log("SECURITY LIST PARTICIPANT BASIC DETAIL");
  console.log(securityList);
  return (
    <>
      <Row>
        <Col lg={12}>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Role</Col>
            <Col xs={6} lg={6} className={styles['value']}>{participant.current.role}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Institution</Col>
            <Col xs={6} lg={6} className={styles['value']}>{participant.current.institutionName}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Primary Contact</Col>
            <Col xs={6} lg={6} className={styles['value']}>
              {`${participant.current.preferredSalutation} `}
              {`${participant.current.primaryContact.firstName} ${participant.current.primaryContact.middleInitial} ${participant.current.primaryContact.lastName}`}
            </Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Title</Col>
            <Col xs={6} lg={6} className={styles['value']}>{participant.current.title}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Mailing Address</Col>
            <Col xs={6} lg={6} className={styles['value']}>
              {
                `${participant.current.address.street} ${participant.current.address.districtOrTown}
                ${participant.current.address.city} ${participant.current.address.stateProvinceRegion}
                ${participant.current.address.country} ${participant.current.address.zipCode}
                `
              }
            </Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Telephone Number</Col>
            <Col xs={6} lg={6} className={styles['value']}>{participant.current.telephoneNumber}</Col>
          </Row>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>Email Address</Col>
            <Col xs={6} lg={6} className={styles['value']}>{participant.current.emailAddress}</Col>
          </Row>
          <Row>
            <Col><div className={styles['spacing']}></div></Col>
          </Row>
          {participant.current.role === 'MarketMaker' && <>
          <Row>
            <Col xs={6} lg={6} className={styles['label']}>{participant.current.securitySubscription.length>1? 'Securities': 'Security'}</Col>
            <Col xs={6} lg={6} className={styles['value']}>
              {
                participant.current.securitySubscription.map((data,index)=>{
                  return index !== 0? ", "+ securityList[parseInt(data)].prefShortName: securityList[parseInt(data)].prefShortName
                })
              }
            </Col>
          </Row>
          <Row>
            <Col><div className={styles['spacing']}></div></Col>
          </Row></>}
        </Col>
      </Row>
    </>
  )
}

const ParticipantAllocationDetails = ({termSheet, participant, setParticipantList, admin, editAllowed}) => {
  //Set participant allocations list state
  console.log(participant.current.allocation, termSheet.securityList)
  const [allocation, setAllocation] = useState(participant.current.allocation);
  //Set dynamic state for allocations (toggleEditFields, loading, message)
  const [ edit, setEdit ] = useState(participant.current.allocation.reduce((m,a) => {
    m[a.id] = false
    return m
  }, {}));
  const [ loading, setLoading ] = useState(participant.current.allocation.reduce((m,a) => {
    m[a.id] = false
    return m
  }, {}));
  const [ message, setMessage ] = useState(participant.current.allocation.reduce((m,a) => {
    m[a.id] = {
      value: '',
      style: '',
    }
    return m
  }, {}));
  //Initialize listing service
  const listingService = new ListingService();
  //Set validation
  const allocationsState = useValidation(allocationsValidator, allocationsObj(participant.current.allocation), {border: '1px solid red'});
  const { validate, getDynamicField, getTextFieldPropsDynamic } = allocationsState;

  const reviseAllocation = async (id, index) => {
    const { formState, isFormValid} = validate();
    console.log(isFormValid, id, formState);
    if (!isFormValid){
      return
    }
    try{
      setLoading({
        ...loading,
        [id]: true
      });
      const result = await listingService.reviseAllocation(termSheet.applicationId,
        participant.current.id, id, formState.allocation[index].amount);
      setAllocation(prev => {
        const newList = prev.map(a => {
          if(a.id === id){
            return {
              ...a,
              history: a.history.concat({
                amount: result.amount,
                date: result.date
              })
            }
          }
          return a
        });
        return newList;
      });
      setParticipantList(prev => {
        console.log(prev);
        const newList = prev.map(p => {
          if(p.role === 'SellingAgent' && p.id === participant.current.id){
            return {
              ...p,
              allocation: p.allocation.map(a => {
                if(a.id === id){
                  return {
                    ...a,
                    amount: result.amount,
                    history: a.history.concat({
                      amount: result.amount,
                      date: result.date
                    })
                  }
                }
                return a
              })
            }
          }
          return p
        })
        return newList;
      });
      setEdit({
        ...edit,
        [id]: !edit[id]
      });
      setMessage({
        ...message,
        [id]: {
          value: LISTING_REVISE_ALLOCATION_SUCCESS,
          style: 'success'
        }
      });
    }catch(error){
      setMessage({
        ...message,
        [id]: {
          value: LISTING_REVISE_ALLOCATION_ERROR,
          style: 'danger'
        }
      });
    }finally {
      setLoading({
        ...loading,
        [id]: false
      });
    }
  }

  const renderEditableFields = (id, securityIndex, value, input) => {
    return edit[id] ? (
      <div className={styles['edit-field']}>
        {input}
        {!loading[id] ?
          <>
            <div onClick={() => reviseAllocation(id, securityIndex)} className={styles['confirm-scale-down']}>
              <img alt="Confirm" src={checkIcon} />
            </div>
            <div onClick={() => setEdit({...edit, [id]: !edit[id]})} className={styles['cancel-scale-down']}>
              <img alt="Cancel" src={rejectIcon}/>
            </div>
          </> : <div className={styles['loading-scale-down']}>
            <Spinner size="sm" animation="border" />
          </div>
        }
      </div>
    ) : (
      <div>
        {value}
        { termSheet.applicationStatus === '2' && !admin && beforeOfferCloses() && editAllowed() ?
          <img className={styles['edit']} onClick={()=>setEdit({...edit, [id]: !edit[id]})} alt="Edit" src={editIcon} /> : ''}
      </div>
    )
  }

  const retrieveSecurityName = a => {
    if (a.id) {
      return termSheet.securityList.filter(s => s.id === a.id)[0].prefShortName;
    }
    return termSheet.securityList[a.securityIndex].prefShortName;
  }

  const beforeOfferCloses = () => {
    const end = strToDate(formatDate(termSheet.offerPeriodTo));
    const now = new Date()
    now.setHours(0,0,0,0);
    return now <= end
  }

  return (
    <>
      <Row>
        <Col lg={12}>
          <Row>
            <Col>
              <div className={styles['table-heading']}>
                Allocations
              </div>
            </Col>
          </Row>
          {allocation.map((a, i) => {
              return (
                <>
                  <Row>
                    <Col lg={12}><div className={styles['line']}></div></Col>
                  </Row>
                  <Row>
                    <Col lg={2} >
                      Security:
                    </Col>
                    <Col lg={10} >
                      <span className={styles['value']}>{' '}{retrieveSecurityName(a)}</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={2} >
                      Amount:
                    </Col>
                    <Col lg={10} >
                      <span className={styles['value']}>
                        {renderEditableFields(
                          a.id,
                          i,
                          toCurrency(getDynamicField('allocation')[i].amount.value),
                          <CurrencyInput inputProps={getTextFieldPropsDynamic('allocation','amount', i)} placeholder={''}/>)}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={10} className={styles[message[a.id].style]}>{message[a.id].value}</Col>
                  </Row>
                  { a.history && a.history.length > 0 ?
                  <Row>
                    <Col>
                      <Table responsive>
                        <thead>
                        <tr>
                          <th className={styles['align-right']}>Amount</th>
                          <th>Date of Revision</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          a.history.map((ah, index) => {
                            return (
                              <tr key={index}>
                                <td className={styles['align-right']}>
                                  {toCurrency(ah.amount)}
                                </td>
                                <td >
                                  { index === 0 ? 'Initial' : ah.date}
                                </td>
                              </tr>
                            )
                          })
                        }
                        </tbody>
                      </Table>
                    </Col>
                  </Row> : ''}
                </>
              )
            })
          }
        </Col>
      </Row>
    </>
  )
}


const allocationsObj = (obj) => {
  obj = obj.map(a => {
    return {
      id: a.id,
      amount: a.amount
    }
  });
  console.log('TEsty', obj);
  return {
    fields: {},
    dynamicFields: {
      allocation: [...obj]
    }
  }
}

const allocationsValidator = {
  fields: {},
  dynamicFields: {
    allocation: {
      amount: [required]
    }
  }
}


export default ParticipantDetailsModalContent;
